import axios from "axios";
import * as fb from "@/plugins/firebase";

const API_URL = process.env.VUE_APP_QUIZ_API_URL;
const API_KEY = process.env.VUE_APP_QUIZ_API_KEY;

//const publicInstance = axios.create({baseURL: `${API_URL}/public`});
const privateInstance = axios.create({baseURL: API_URL});
const fileInstance = axios.create({baseURL: API_URL});

const OnAuthenticatedRequest = async (config) => {
    const token = await fb.auth.currentUser.getIdToken(true);

    config.headers["X-Api-Authentication"] = `api-key ${API_KEY}`
    config.headers["Authorization"] = `Bearer ${token}`
    config.headers["Accept"] = "application/json"
    config.headers["Content-Type"] = "application/json"
    config.headers["Access-Control-Allow-Origin"] = "*"
    return config;
};

const OnResponse = () => {
    return response => {

        if (response.data && response.data.success && response.data.body) {
            return response.data.body;
        } else {
            return OnError(response.error);
        }
    };
};

const OnFileResponse = () => {
    return response => {
        if (response.status === 200) {
            return response;
        } else {
            console.error(`api response error: ${response.error}`)
            return Promise.reject(response.error);
        }
    }
};

const OnError = error => {
    console.log('error', error)
    return Promise.reject(error);
};

// Request interceptor for API calls
privateInstance.interceptors.request.use(OnAuthenticatedRequest, OnError());
fileInstance.interceptors.request.use(OnAuthenticatedRequest, OnError());

// Response interceptor for API calls
//publicInstance.interceptors.response.use(OnResponse(), OnError());
privateInstance.interceptors.response.use(OnResponse(), OnError());
fileInstance.interceptors.response.use(OnFileResponse(), OnError());


const myAxios = {
    privateInstance: privateInstance,
    fileInstance: fileInstance
};

export default myAxios;